import MuiLink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import React from "react";
import { Link } from "react-router-dom";

interface FormHeaderSectionProps {
  title: string;
  description: string;
  link?: string;
  path?: string;
  handleClick?: () => void;
}

const FormHeaderSection: React.FC<FormHeaderSectionProps> = ({
  title,
  description,
  link,
  path,
  handleClick,
}) => {
  return (
    <div>
      <Typography variant="h5" fontSize={32} fontWeight={600}>
        {title}
      </Typography>
      <Typography variant="body1">
        {`${description} `}

        {path && link && (
          <Link to={path} style={{ fontSize: "inherit", color: "#1147EA" }}>
            {link}
          </Link>
        )}

        {handleClick && link && (
          <MuiLink
            variant="body1"
            underline="none"
            onClick={handleClick}
            sx={{ fontSize: "inherit" }}
          >
            {link}
          </MuiLink>
        )}
      </Typography>
    </div>
  );
};

export default FormHeaderSection;
